import React from "react";
import styled from "styled-components";
import { Pagination as MuiPagination } from "@material-ui/lab";

const StyledPagination = styled(MuiPagination)`
  .MuiPagination-ul {
    justify-content: center;
  }
`;

interface IPaginationProps {
  count: number;
  page: number;
  onChange: (newPage: number) => void;
}

const Pagination: React.VFC<IPaginationProps> = (props) => {
  const { count, page, onChange } = props;

  const handlePageChange = (event: any, value: number) => {
    onChange?.(value);
  };

  return (
    <StyledPagination
      count={count}
      page={page}
      color="primary"
      onChange={handlePageChange}
    />
  );
};

export default Pagination;
